import { useIntl } from 'react-intl';
import { type IChallengeCarouselItem } from '../../../../common/interfaces';
import { NO_IMAGE_PLACEHOLDER } from '../../common/const';
import { useRuntimeCommunity } from '../../../../context';
import { decodeHtml } from '../../../../helpers';
import {
  Slide,
  SlideDescription,
  SlideImage,
  SlideLink,
  SlideStatIcon,
  SlideStatItem,
  SlideStats,
  SlideSubtitle,
  SlideTitle
} from './ChallengeCarouselSlide.styled';

export interface CarouselSlideProps {
  slideData: IChallengeCarouselItem;
  hideDescription: boolean;
  tabIndex?: number;
  inert?: string;
}

export const ChallengeCarouselSlide = ({ slideData, hideDescription, tabIndex = 0, inert }: CarouselSlideProps) => {
  const intl = useIntl();
  const { colors } = useRuntimeCommunity();
  const ariaLabel = `${intl.formatMessage({ id: 'challengeCarouselSlide', defaultMessage: 'Challege carousel slide' })}.`;
  const decodedTitle = decodeHtml(slideData?.title);

  return (
    <Slide data-testid="challenge-carousel-slide" {...(inert && { inert })}>
      <SlideLink href={slideData?.linkUrl} aria-label={ariaLabel} tabIndex={tabIndex}>
        <SlideImage aria-hidden="true">
          <img src={slideData.imageUrl || NO_IMAGE_PLACEHOLDER} alt={decodedTitle} />
          {!hideDescription && (
            <SlideDescription id="slide-description" bgColor={colors.button}>
              <div>
                <SlideTitle>{decodedTitle}</SlideTitle>
                <SlideSubtitle>{decodeHtml(slideData?.subtitle)}</SlideSubtitle>
              </div>
              <SlideStats>
                <SlideStatItem>
                  <SlideStatIcon className="mdl-icon -s" aria-hidden="true">
                    <svg>
                      <use href="#idea" />
                    </svg>
                  </SlideStatIcon>
                  {slideData?.ideaCount}
                </SlideStatItem>
              </SlideStats>
            </SlideDescription>
          )}
        </SlideImage>
      </SlideLink>
    </Slide>
  );
};
